<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.grades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-3 flex space-x-2">
            <div v-for="trimester in [1, 2, 3]" :key="trimester">
                <inertia-link-button
                    :href="`?trimester=${trimester}`"
                    :type="trimester == selectedTrimester ? 'primary' : 'white'"
                >
                    {{ $t('messages.trimester') }} {{ trimester }}
                </inertia-link-button>
            </div>
        </div>

        <div>
            <apexchart :type="gradesChart.chart.type" height="500" :series="gradesChart.series" :options="gradesChart">
            </apexchart>
        </div>

        <div class="mt-3 flex flex-wrap space-x-2">
            <div v-for="category in categories" :key="category.id">
                <inertia-link-button
                    v-if="category.average_score"
                    :href="
                        route('students.grades.domain.show', {
                            category: category,
                            trimester: selectedTrimester,
                        })
                    "
                    type="white"
                >
                    {{ category.name }}
                </inertia-link-button>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: { PanelPage },
    layout: Layout,
    name: 'Index',
    props: ['gradesChart', 'categories', 'selectedTrimester'],
    data() {
        return {};
    },
    computed: {
        filteredForm: function () {
            return [];
        },
    },
    methods: {
        getParams() {
            return [];
        },
    },
};
</script>
